import { mapToTrackableProduct } from 'src/app/@utils/gtm-tracking/utils/mapToTrackableProduct';

import { ProductSearchViewModel } from '@models/api-search.models';
import { PromotionSettings, PromotionViewEventBase } from '@utils/gtm-tracking/model/Promotion';
import { generatePromotion } from '@utils/gtm-tracking/utils/generatePromotion';

export type PromotionClickEvent = Omit<PromotionViewEventBase, 'event'> & {
    event: 'select_promotion';
};

export const trackPromotionClickEvent = (promoSetting: PromotionSettings, product?: ProductSearchViewModel): PromotionClickEvent => ({
    event: 'select_promotion',
    ...generatePromotion(promoSetting, product),
    ...(product ? {items: [mapToTrackableProduct(product)]} : {})
});
